import React from 'react';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Sarah Ahmed',
    company: 'StartupPro',
    text: "Skript took our idea from napkin sketch to polished product — all within a month. Their team’s dedication and speed blew us away!",
  },
  {
    name: 'Omar Khalil',
    company: 'Fintronix',
    text: "They didn’t just build what we asked for — they improved it. Their AI quoting tool made getting started fast and clear.",
  },
  {
    name: 'Jana Haddad',
    company: 'Appify',
    text: "What I appreciated most was how collaborative Skript’s approach was. We felt like true partners throughout the project.",
  },
  {
    name: 'Nour Taleb',
    company: 'WebInnovate',
    text: "From MVP to full-scale platform, Skript was there. Transparent, communicative, and genuinely passionate about code.",
  },
];

const Testimonials = () => {
  return (
    <div className="testimonials-container">
      <div className="testimonials-hero">
        <h1 className="testimonials-title">What Our Clients Say</h1>
        <p className="testimonials-subtitle">
          Real feedback from companies we’ve helped turn ideas into impactful digital products.
        </p>
      </div>

      <div className="testimonials-grid">
        {testimonials.map((t, index) => (
          <div key={index} className="testimonial-card">
            <p className="testimonial-text">“{t.text}”</p>
            <div className="testimonial-author">
              <span className="author-name">{t.name}</span> – <span className="author-company">{t.company}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Testimonials;
